// extracted by mini-css-extract-plugin
export default {"Loader_Back":"Loader_Loader_Back__c4EHx","Loader":"Loader_Loader__aLOnO","rotatey":"Loader_rotatey__uW9pk"};